import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  /**
   * This is a dummy component, that will never be shown, as the route guard will always redirect to the external microsoft login page!
   */
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {}
